import React from 'react';
import PropTypes from 'prop-types';

export default function SidebarLogoutIcon({ className = 'h-[18px] w-[18px]', strokeWidth = 1.6 }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
    >
      <path d='M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9' />
    </svg>
  );
}

SidebarLogoutIcon.propTypes = {
  className: PropTypes.string,
  strokeWidth: PropTypes.number,
};
